import { useEffect, useRef } from 'react'

function appendConversionTags(root: HTMLDivElement, fragment: string) {
  const elements = parse(fragment)
  append(root, elements)
}

// DOMParser は script を実行しないので createContextualFragment でないといけない
// https://www.w3.org/TR/DOM-Parsing/#widl-DOMParser-parseFromString-Document-DOMString-str-SupportedType-type
// > Parse str with an HTML parser, and return the newly created document.
// > The scripting flag must be set to "disabled".
function parse(fragment: string): Element[] {
  const r = document.createRange()
  const f = document.createDocumentFragment()
  const div = document.createElement('div')
  f.appendChild(div)
  r.selectNode(div)
  const df = r.createContextualFragment(fragment)
  return [...df.querySelectorAll('*')]
}

// 複数の要素があった場合に DOM に反映されてから次のタグを追加する。
//
// 一度に HTMLCollection を appendChild すると並列で script が実行されてしまう。
// 以下のような例の場合に conversion_id が未設定の状態でコンバージョン本体が実行されてしまわないように。
//
// <script>
// var example_conversion_id = 1000000000;
// <script>
// <script src="https://example.com/conversion.js" async></script>
function append(root: HTMLDivElement, elements: Element[]) {
  if (elements.length === 0) {
    return
  }
  const [first, ...rest] = elements
  if (waitLoad(first)) {
    first.onload = () => {
      append(root, rest)
    }
    root.appendChild(first)
  } else {
    root.appendChild(first)
    setTimeout(() => {
      append(root, rest)
    }, 0)
  }
}

// async/defer 属性がない場合はロードが完了されるまでを待つ
// <script src="https://example.com/conversion.js"></script>
function waitLoad(elm: Element): elm is HTMLScriptElement {
  if (!(elm instanceof HTMLScriptElement)) {
    return false
  }
  return !elm.async && !elm.defer && !!elm.src
}

export const ConversionTag: React.FC<{ tag: string; className?: string }> = ({
  tag,
  className,
}) => {
  // 一度しか useEffect が実行されないことを保証する
  const rendered = useRef(false)
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (ref.current !== null && !rendered.current) {
      appendConversionTags(ref.current, tag)
      rendered.current = true
    }
  }, [ref, rendered, tag])
  return <div ref={ref} className={className} />
}
